var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"errorRef",staticClass:"alert alert-danger alert-icon",attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-content"},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }